import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Input, Select } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';

import GetField from '../Components/GetField';
import stylesCSS from '../styles';
import {
  getTotal,
  getProductTotalA,
  getProductTotalB,
  getProductTotalC,
} from './common-functions';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);
const { Option } = Select;

const PositionForm = props => {
  const {
    classes,
    getValues,
    setValue,
    control,
    watch,
    positionItem,
    positionIndex,
    positionAppend,
    positionRemove,
    styleIndex,
  } = props;

  useEffect(() => {
    const price =
      getValues(`styles[${styleIndex}].positions[${positionIndex}].price`) || 0;
    const avg =
      getValues(`styles[${styleIndex}].positions[${positionIndex}].avg`) || 0;

    const total = +(+price * +avg).toFixed(2);

    setValue(`styles[${styleIndex}].positions[${positionIndex}].total`, total);
  }, [
    watch(`styles[${styleIndex}].positions[${positionIndex}].price`),
    watch(`styles[${styleIndex}].positions[${positionIndex}].avg`),
  ]);

  useEffect(() => {
    const fabrics = getValues(`styles[${styleIndex}].fabrics`);
    const positions = getValues(`styles[${styleIndex}].positions`);
    const processes = getValues(`styles[${styleIndex}].processes`);

    setValue(
      `styles[${styleIndex}].total`,
      getTotal(fabrics, positions, processes)
    );

    const styles = getValues(`styles`);
    setValue(`productTotalA`, getProductTotalA(styles));
    setValue(`productTotalB`, getProductTotalB(styles));
    setValue(`productTotalC`, getProductTotalC(styles));
  }, [watch(`styles[${styleIndex}].positions[${positionIndex}].total`)]);

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].positions[${positionIndex}].position`}
          control={control}
          defaultValue={positionItem.position}
          render={({ field }) => (
            <AntInput placeholder="Position" {...field} size="small" />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].positions[${positionIndex}].fabric`}
          control={control}
          defaultValue={positionItem.fabric}
          render={({ field }) => (
            <AntSelect
              placeholder="Select fabric"
              {...field}
              onChange={value => {
                field.onChange(value);

                const fabricObj =
                  watch(`styles[${styleIndex}].fabrics`)
                    .filter(
                      fabric =>
                        fabric.fabric && fabric.width && fabric.baseColor
                    )
                    .find(
                      fabric =>
                        `${fabric.fabric} ${fabric.width} ${fabric.baseColor} ${
                          fabric.printColor || ''
                        }`.trim() === value
                    ) || {};

                setValue(
                  `styles[${styleIndex}].positions[${positionIndex}].price`,
                  fabricObj.total || 0
                );
              }}
            >
              {watch(`styles[${styleIndex}].fabrics`)
                .filter(
                  fabric => fabric.fabric && fabric.width && fabric.baseColor
                )
                .map(fabric => (
                  <Option
                    key={`${fabric.fabric} ${fabric.width} ${
                      fabric.baseColor
                    } ${fabric.printColor || ''}`.trim()}
                    value={`${fabric.fabric} ${fabric.width} ${
                      fabric.baseColor
                    } ${fabric.printColor || ''}`.trim()}
                  >
                    {`${fabric.fabric} ${fabric.width} ${fabric.baseColor} ${
                      fabric.printColor || ''
                    }`.trim()}
                  </Option>
                ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].positions[${positionIndex}].price`}
          control={control}
          defaultValue={positionItem.price}
          render={({ field }) => (
            <AntInput
              placeholder="Price"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].positions[${positionIndex}].avg`}
          control={control}
          defaultValue={positionItem.avg}
          render={({ field }) => (
            <AntInput
              placeholder="Avg"
              {...field}
              type="number"
              min={0}
              size="small"
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].positions[${positionIndex}].total`}
          control={control}
          defaultValue={positionItem.total}
          render={({ field }) => (
            <AntInput
              placeholder="Total"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined
          onClick={() => {
            const positions = getValues(`styles[${styleIndex}].positions`);

            if (positions && positions.length > 5 && positionIndex >= 5) {
              positionRemove(positionIndex);
            }
          }}
        />
        &nbsp; &nbsp;
        <PlusCircleOutlined
          onClick={() =>
            positionAppend({
              position: null,
              fabric: null,
              price: null,
              avg: null,
              total: null,
            })
          }
        />
      </td>
    </tr>
  );
};

PositionForm.propTypes = {
  classes: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  watch: PropTypes.func.isRequired,
  positionItem: PropTypes.object.isRequired,
  positionIndex: PropTypes.number.isRequired,
  positionAppend: PropTypes.func.isRequired,
  positionRemove: PropTypes.func.isRequired,
  styleIndex: PropTypes.number.isRequired,
};

export default withStyles(stylesCSS)(PositionForm);
